import styled from '@emotion/styled'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useTeams } from 'features/Timeline/hooks/useTeams'
import React, { useMemo } from 'react'
import profileLogo from '../../../images/profile_logo.png'
import { useAuthContext } from '../../context/AuthProvider'
import { useDrawersContext } from '../../context/ClientsDrawersProvider'
import HelpTooltip, { MobileTooltipWithIcon } from '../../tooltips/HelpTooltip'
import { profileOfConcernTooltip, traineeProfileTooltip } from '../../tooltips/tooltips'

const Container = styled(Box)`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, #71cacb 0%, #005b8c 100%);
`

const getFirstLetter = (str: string | undefined) => {
  if (!str) {
    return ''
  }
  if (str[0]) {
    return str[0] + '.'
  }
  return ''
}

const ProfileBanner = () => {
  const { isTrainee, user } = useAuthContext()
  const { handleOpenProfile, handleOpenConcernProfile } = useDrawersContext()
  const { activeTeamCarePerson, concernProfileCarePersonId } = useTeams()

  const profileName = useMemo(() => {
    if (!user) {
      return ''
    }

    if (isTrainee) {
      return (user.firstname || '') + ' ' + getFirstLetter(user.lastname)
    }

    const fromActiveTeam =
      activeTeamCarePerson && (activeTeamCarePerson.firstname || activeTeamCarePerson.lastname)
        ? `${activeTeamCarePerson.firstname} ${activeTeamCarePerson.lastname}`
        : ''

    if (fromActiveTeam) {
      return fromActiveTeam
    }

    return `${user.personOfConcernFirstName || ''} ${user.personOfConcernLastName || ''}`
  }, [isTrainee, user, activeTeamCarePerson])

  const profileTypeText = isTrainee ? 'Trainee Profile' : 'Person of Concern'

  const onClickProfile = () => {
    if (isTrainee) {
      handleOpenProfile(user?.id)
    } else {
      handleOpenConcernProfile()
    }
  }

  return (
    <Container>
      <Typography variant="h5" color="white" sx={{ mb: 2 }}>
        Welcome
      </Typography>
      <Box sx={{ mb: 1 }}>
        <img src={profileLogo} alt="Logo" />
      </Box>
      <Typography variant="body2" color="white">
        {profileTypeText}
      </Typography>
      <Typography variant="h6" color="white" fontWeight={400} sx={{ mb: 2 }}>
        {profileName}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ color: 'white' }}>
        <HelpTooltip
          text={isTrainee ? traineeProfileTooltip : profileOfConcernTooltip}
          placement="right"
        >
          <Button variant="contained" onClick={onClickProfile}>
            View/Edit Profile
          </Button>
        </HelpTooltip>

        <MobileTooltipWithIcon
          text={isTrainee ? traineeProfileTooltip : profileOfConcernTooltip}
          placement="bottom"
        />
      </Stack>
    </Container>
  )
}

export default ProfileBanner
